// dls
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

import styled from "styled-components";

// Full-screen overlay above the curtain raiser (curtain uses zIndex 999).
// background_Primary flips per theme: black in dark mode, white in light mode.
export const AgeGateContainer = styled.div(({ theme }) => ({
    position: "fixed",
    inset: 0,
    zIndex: 1000,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    // Safety net for anything the max-height query below still doesn't cover (e.g. landscape).
    overflowY: "auto",
    // Top padding has no matching DLS token (scale tops out at xxLarge/32px); sides use xLarge.
    padding: `48px ${theme.spacing.xLarge} ${theme.spacing.xLarge}`,
    background: theme.colors[theme.colorMode].background_Primary,

    // Compact layout so the CTA fits on short screens (e.g. iPhone SE, ~667px tall) without
    // needing to scroll — the circle is the single biggest contributor to the overflow.
    "@media (max-height: 700px)": {
        padding: `${theme.spacing.xLarge} ${theme.spacing.xLarge}`,
    },
}));

export const Heading = styled(Text)(({ theme }) => ({
    textAlign: "center",
    marginTop: theme.spacing.medium,
}));
export const HeadingTop = styled(Text)(({ theme }) => ({
    textAlign: "center",
    marginTop: theme.spacing.xLarge,
}));
export const AgeCircle = styled.div(({ theme }) => ({
    // aspectRatio (instead of a separate height) keeps this a perfect circle if the width is
    // ever resized — height always matches width, so it can't stretch into an oval.
    width: "208px",
    aspectRatio: "1",
    borderRadius: "50%",
    border: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: `${theme.spacing.xLarge} 0`,

    "@media (max-height: 700px)": {
        width: "144px",
        margin: `${theme.spacing.large} 0`,
    },
}));

// No DLS typography variant goes this large — override size on top of the variant's
// family/weight, same pattern as CurtainRaiser's `UserText = styled(Text)({...})`.
export const AgeNumber = styled(Text)({
    fontSize: "64px",
    lineHeight: "77px",
    letterSpacing: "-1.28px",
});

export const Divider = styled.div(({ theme }) => ({
    width: "100%",
    height: "1px",
    background: theme.colors[theme.colorMode].divider,
    // Top bumped by 16px over the token value for breathing room above the divider.
    // Bottom bumped by 4px (16px - 12px) — same base adjustment, pulled back in by 12px.
    margin: `calc(${theme.spacing.xSmall} + 16px) 0 calc(${theme.spacing.large} + 4px)`,
}));

export const LegalText = styled(Text)({
    textAlign: "center",
});

// minHeight keeps a floor between the legal text and the CTA on short screens, where flex:1
// alone could shrink to 0 and butt the CTA directly against the text above it.
export const Spacer = styled.div(({ theme }) => ({
    flex: 1,
    minHeight: theme.spacing.xLarge,

    "@media (max-height: 700px)": {
        minHeight: theme.spacing.medium,
    },
}));

// Inverse of the container's background_Primary so the CTA stays visible on either theme
// (white pill on black in dark mode, black pill on white in light mode).
export const AgreeButton = styled.button(({ theme }) => ({
    width: "100%",
    padding: theme.spacing.large,
    border: "none",
    borderRadius: theme.cornerRadius.medium,
    background: theme.colors[theme.colorMode].background_inverse_Primary,
    cursor: "pointer",
}));

export const CancelButton = styled.button(({ theme }) => ({
    width: "100%",
    padding: theme.spacing.large,
    border: "none",
    background: "transparent",
    cursor: "pointer",
}));
